// extracted by mini-css-extract-plugin
export default {"account":"ab5Db","inverted":"_b9Ls","accountDropdown":"TIMGl","chevronIcon":"c5Fkv","opened":"CXckQ","signIn":"Ofxs1","register":"Es0hd","name":"zztup"};